/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */


import { VisRecommenderAPI } from './VisRecommenderAPI'

define([], function() {

	class VisRecommenderService {

		initialize(glassContext) {
			return glassContext
				.getSvc('.SmartsService')
				.then(SmartsAPI => {
					this._visRecommenderAPI = VisRecommenderAPI({
						SmartsAPI,
						logger: glassContext.getCoreSvc('.Logger')
					})
				})
		}

		/**
		 * Returns the vis recommendations from VisRecommender
		 *
		 * @param requestParams which consists of:
		 *  - sourceModuleId - id of source module
		 *  - sourceType - source type is one of 'uploadedFile, module, etc'
		 *  - chartsToInclude - charts to be considered for recommendation (provided it is also supported by vis recommender)
		 *  - columns - columns used for recommending. Columns are
		 *    [
		 *    {  id: [columnId_1, columnId_2, ...]} or
		 *    {
		 *   		id: [columnId_1, columnId_3
		 *    	  slot:	<slotName>
		 *   	}
		 *
		 * ]
		 * - numResults - number of recommendations to return.  Default is 10 if none is supplied.
		 * - hasShaping - true if there is shaping done (specific to Dashboard/Explore).
		 * - tempModuleObject - temp session module object
		 * - oneChartPerType - true means that only one variation per chart type is returned
		 *
		 * @returns promise which resolves to Vis Recommender response
		 */
		recommend(requestParams) {
			return this._visRecommenderAPI.recommend(requestParams)
		}
	}

	return VisRecommenderService
})
